import { defineMessages } from '@transcend-io/internationalization';

export const requestPreviewMessages = defineMessages(
  'privacy-center.containers.RequestPreview.requestPreview',
  {
    requestMadeTitle: {
      defaultMessage: 'Your data subject request has been made',
      description:
        'The message title that is displayed in the "Active Requests" dropdown when a privacy request was recently made.',
    },
    requestMadeDescription: {
      defaultMessage:
        'We will begin verifying and processing your request ({ title }).',
      description:
        'The message description that is displayed in the "Active Requests" ' +
        'dropdown when a privacy request was recently made.',
    },
    failedVerificationTitle: {
      defaultMessage: 'Verification failed',
      description:
        'The message title that is displayed in the "Active Requests" dropdown when a privacy request failed verification.',
    },
    failedVerificationDescription: {
      defaultMessage: `We tried to verify your identity,
but you never clicked the link in your email.
We had to cancel your request ({ title }).`,
      description:
        'The message description that is displayed in the "Active Requests" ' +
        'dropdown when a privacy request failed verification.',
    },
    processingTitle: {
      defaultMessage: 'Your request is in progress',
      description:
        'The message title that is displayed in the "Active Requests" ' +
        'dropdown when a privacy request is actively being processed.',
    },
    processingDescription: {
      defaultMessage:
        // eslint-disable-next-line max-len
        "Please wait as we handle your request ({ title }). We'll send you an email when your report is ready or you can check back here and reload the page.",
      description:
        'The message that is displayed in the request dropdown when the privacy requests is actively being processed.',
    },
    onHoldTitle: {
      defaultMessage: 'Your request has been placed on hold',
      description:
        'The message title that is displayed in the "Active Requests" dropdown when a privacy request is on hold.',
    },
    onHoldDescription: {
      defaultMessage:
        'You are unauthenticated to make this request ({ title }). We will notify you of any changes in the future.',
      description:
        'The message description that is displayed in the "Active Requests" ' +
        'dropdown when a privacy request is on hold.',
    },
    delayedTitle: {
      defaultMessage: 'Your request is currently pending',
      description:
        'The message title that is displayed in the "Active Requests" dropdown when a privacy request is delayed.',
    },
    delayedDescription: {
      defaultMessage: `We have begun the process of deleting your account.
For security purposes, we require a window of time to allow you to cancel this request if you did not intend to make it.
Your account will be deleted {time}.`,
      description:
        'The message description that is displayed in the "Active Requests" ' +
        'dropdown when a privacy request is delayed.',
    },
    downloadableTitle: {
      defaultMessage: 'Your data is ready to view and download',
      description:
        'The message title that is displayed in the "Active Requests" dropdown ' +
        'when the privacy request data is ready to download.',
    },
    downloadableDescription: {
      defaultMessage: 'Download an archive of all your files.',
      description:
        'The message description that is displayed in the "Active Requests" dropdown ' +
        'when the privacy request data is ready to download.',
    },
    completedTitle: {
      defaultMessage: 'Your request has been completed',
      description:
        'The message title that is displayed in the "Active Requests" ' +
        'dropdown when a privacy request has been completed.',
    },
    completedDescription: {
      defaultMessage:
        'We have successfully completed your request ({ title }).',
      description:
        'The message description that is displayed in the "Active Requests" ' +
        'dropdown when a privacy request has been completed.',
    },
    canceledTitle: {
      defaultMessage: 'Your data request has been canceled',
      description:
        'The message title that is displayed in the "Active Requests" dropdown ' +
        'when a privacy request has been canceled.',
    },
    canceledDescription: {
      defaultMessage:
        'Rest easy. Your data is safe. We will no longer process your request ({ title }).',
      description:
        'The message description that is displayed in the "Active Requests" ' +
        'dropdown when a privacy request has been canceled.',
    },
    secondaryTitle: {
      defaultMessage: 'Deletion request in process',
      description:
        'The message title that is displayed in the "Active Requests" dropdown when a deletion request is in process.',
    },
    secondaryDescription: {
      defaultMessage:
        'We are in the process of removing all of your records from our systems.',
      description:
        'The message description that is displayed in the "Active Requests" ' +
        'dropdown when a deletion request is in process.',
    },
    secondaryCompletedTitle: {
      defaultMessage: 'Your erasure request is complete',
      description:
        'The message title that is displayed in the "Active Requests" dropdown ' +
        'when a deletion request has been completed.',
    },
    secondaryCompletedDescription: {
      defaultMessage: 'All of your records have been removed from our systems.',
      description:
        'The message description that is displayed in the "Active Requests" ' +
        'dropdown when a deletion request has been completed.',
    },
    revokedTitle: {
      defaultMessage: 'You have canceled your data request',
      description:
        'The message title that is displayed in the "Active Requests" dropdown ' +
        'when a privacy request has been revoked.',
    },
    revokedDescription: {
      defaultMessage:
        'You let us know that you did not want the request ({ title }) to occur, or you made another identical request.',
      description:
        'The message description that is displayed in the "Active Requests" ' +
        'dropdown when a privacy request has been revoked.',
    },
  },
);
